import { Link } from 'react-router-dom'
import { ISection, IMenu } from '../../../../types/menu'
import { useApp } from '../../../../context/App'

interface Props {
	section: ISection
}

export function SubItemMenuNav({ section }: Props) {
	const { getTenantUrl } = useApp()

	return (
		<div className="mb-4 last:mb-0">
			<div className="px-3 mb-2 font-bold text-[0.625rem] uppercase tracking-widest text-on-surface-subtle dark:text-on-surface-dark-muted border-l-2 border-secondary ml-px">
				{section.titulo}
			</div>

			<div className="flex flex-col gap-0.5">
				{section.menus?.map((item: IMenu, index: number) => {
					let subMenuNav_link = '#'
					let isInternal = false

					if (item.ref_cod_artigo) {
						subMenuNav_link = '/a/' + item.ref_cod_artigo
						isInternal = true
					} else if (item.ref_cod_entidade) {
						subMenuNav_link = '/e/' + item.ref_cod_entidade
						isInternal = true
					} else if (item.link) {
						subMenuNav_link = item.link
					}

					let subMenuNav_target = item.nova_janela ? '_blank' : '_self'

					return (
						isInternal ? (
							<Link
								key={index}
								to={getTenantUrl(subMenuNav_link)}
								className="no-underline text-on-surface dark:text-on-surface-dark text-[0.6875rem] font-medium transition-all duration-200 hover:text-primary dark:hover:text-secondary hover:bg-surface-alt dark:hover:bg-white/5 px-3 py-1.5 rounded-lg block"
							>
								{item.titulo}
							</Link>
						) : (
							<a
								key={index}
								href={getTenantUrl(subMenuNav_link)}
								target={`${subMenuNav_target}`}
								rel={subMenuNav_target === '_blank' ? "noreferrer" : ""}
								className="no-underline text-on-surface dark:text-on-surface-dark text-[0.6875rem] font-medium transition-all duration-200 hover:text-primary dark:hover:text-secondary hover:bg-surface-alt dark:hover:bg-white/5 px-3 py-1.5 rounded-lg block"
							>
								{item.titulo}
							</a>
						)
					)
				})}
			</div>
		</div>
	)
}